import { SharedState } from '@trello/shared-state';

import type { Action } from './PluginHeader';

type PluginBoardBarContent = {
  url: string;
  height: number;
  accentColor: string;
  callback?: () => void;
  title?: string;
  actions?: Action[];
  resizable?: boolean;
};

type PluginBoardBarOptions = {
  isOpen: boolean;
  content: PluginBoardBarContent;
};

export const PluginBoardBarState = new SharedState<PluginBoardBarOptions>({
  isOpen: false,
  content: {
    url: '',
    height: 0,
    accentColor: '',
  },
});
